import { render, staticRenderFns } from "./Cancha.vue?vue&type=template&id=6bab19b9&scoped=true&"
import script from "./Cancha.vue?vue&type=script&lang=js&"
export * from "./Cancha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab19b9",
  null
  
)

export default component.exports